export default __webpack_public_path__ + "static/media/login.9e2e60aa.png";